import { render, staticRenderFns } from "./TeamRequestListSkeleton.vue?vue&type=template&id=f13365d0&scoped=true"
import script from "./teamRequestListSkeleton.ts?vue&type=script&lang=ts&external"
export * from "./teamRequestListSkeleton.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequestListSkeleton.vue?vue&type=style&index=0&id=f13365d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13365d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f13365d0')) {
      api.createRecord('f13365d0', component.options)
    } else {
      api.reload('f13365d0', component.options)
    }
    module.hot.accept("./TeamRequestListSkeleton.vue?vue&type=template&id=f13365d0&scoped=true", function () {
      api.rerender('f13365d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-list-skeleton/TeamRequestListSkeleton.vue"
export default component.exports